import browser from "webextension-polyfill";
import { closeIcon } from "../img/close.js";
import { createIframePlayer, createBackdrop, videoContextStore, createLogoSVG, } from "./shared.js";
import { ytHavenModalClosed } from "../shared/index.js";
const modalId = "yt-haven-modal";
function createCloseButton() {
    const closeButton = document.createElement("button");
    closeButton.ariaLabel = "close overlay";
    closeButton.innerHTML = closeIcon;
    closeButton.style.position = "absolute";
    closeButton.style.top = "1rem";
    closeButton.style.right = "1rem";
    closeButton.style.cursor = "pointer";
    closeButton.style.background = "none";
    closeButton.style.border = "none";
    return closeButton;
}
function createBrandingElement() {
    const logo = createLogoSVG();
    logo.style.height = "1.875rem";
    const brandingElement = document.createElement("div");
    brandingElement.style.marginTop = "2rem";
    brandingElement.style.color = "#FFF";
    brandingElement.style.fontSize = "1.25rem";
    brandingElement.style.display = "flex";
    brandingElement.style.alignItems = "center";
    brandingElement.style.gap = "1rem";
    brandingElement.innerText = browser.i18n.getMessage("yt_haven_player_watching_with_label", "");
    brandingElement.appendChild(logo);
    return brandingElement;
}
export function addVideoModal(targetElement) {
    const modalContainer = createBackdrop(modalId);
    modalContainer.style.position = "fixed";
    modalContainer.style.zIndex = "999999";
    const closeButton = createCloseButton();
    const brandingElem = createBrandingElement();
    const { videoId, playlistId, startSeconds } = videoContextStore.getVideoContext();
    const playerElem = createIframePlayer({
        videoId,
        playlistId,
        startSeconds,
        showInModal: true,
    });
    modalContainer.appendChild(closeButton);
    modalContainer.appendChild(playerElem);
    modalContainer.appendChild(brandingElem);
    targetElement.appendChild(modalContainer);
    function handleModalClose() {
        targetElement.removeChild(modalContainer);
        void browser.runtime.sendMessage({
            type: ytHavenModalClosed,
        });
    }
    function closeModalOnKeydown(evt) {
        if (evt.key === "Escape") {
            handleModalClose();
            targetElement.removeEventListener("keydown", closeModalOnKeydown);
        }
    }
    function closeModalOnClick(evt) {
        var _a;
        if (((_a = evt.target) === null || _a === void 0 ? void 0 : _a.id) === modalId) {
            handleModalClose();
            targetElement.removeEventListener("click", closeModalOnClick);
        }
    }
    function closeModalButtonClick() {
        handleModalClose();
        closeButton.removeEventListener("click", closeModalButtonClick);
    }
    closeButton.addEventListener("click", closeModalButtonClick);
    targetElement.addEventListener("keydown", closeModalOnKeydown);
    targetElement.addEventListener("click", closeModalOnClick);
}
export function removeVideoModal() {
    var _a;
    const modalContainer = document.getElementById(modalId);
    (_a = modalContainer === null || modalContainer === void 0 ? void 0 : modalContainer.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(modalContainer);
}
